module.exports = __webpack_public_path__ + "assets/img/station26.2c35f452.png";